import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitConversion',
})
export class UnitConversionPipe implements PipeTransform {
  transform(value: number, conversionRate: number, unit: string, decimals = 2): string {
    if (value === null || value === undefined) return ''; // Handle null and undefined values

    const convertedValue = value * conversionRate;
    const roundedValue = Number(convertedValue.toFixed(decimals)); // Round and convert back to number

    // Check if the rounded value has any fractional part
    const displayValue = roundedValue % 1 === 0 ? roundedValue.toFixed(0) : roundedValue.toFixed(decimals);

    return `${displayValue} ${unit}`; // Format the output with the unit
  }
}
